import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FileFormats } from "../../../components/forms/libs/data/fileFormatTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";

export const HideShowInsoleMemberFieldsConfig = [
    {
        id: "reasonId",
        label: "Reason",
        Field_Name: "Reason",
        fieldType: FormFieldTypes.SELECT,
        dataField: "reasonId",
        fieldSetting: {
            placeholder: "Select Reason",
            allowSpace: true,
            options: [],
            isDisable: false
        },
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
]

export const HideShowIsCriminalOffenceFieldsConfig = [
    {
        id: "criminaloffenceMoreDetails",
        label: "If yes, please provide more details",
        Field_Name: "If yes, please provide more details",
        fieldType: FormFieldTypes.INPUT,
        dataField: "criminaloffenceMoreDetails",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },

        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
]

export const HideShowIsBenifitsOfYourCreditorsFieldsConfig = [
    {
        id: "benifitsOfYourCreditorsMoreDetails",
        label: "If yes, please provide more details",
        Field_Name: "If yes, please provide more details",
        fieldType: FormFieldTypes.INPUT,
        dataField: "benifitsOfYourCreditorsMoreDetails",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },

        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
]

export const HideShowSupportFileFieldConfig = [
    {
        id: "detailedListAppRoleRespoFile",
        label: "A detailed list specifying the Applicant's role/responsibilities in R&I matters for at least the last seven years.",
        Field_Name: "A detailed list specifying the Applicant's role/responsibilities in R&I matters for at least the last seven years.",
        fieldType: FormFieldTypes.FILE,
        dataField: "detailedListAppRoleRespoFile",
        fieldSetting: {
            allowMultipleFiles: false,
            acceptedFileFormats: [
                FileFormats.PDF,
                FileFormats.DOC,
                FileFormats.DOCX,
                FileFormats.XLSX,
            ],
            minFileSizeInMB: 0, // Minimum File size in MB
            maxFileSizeInMB: 2, // Maximum File size in MB
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss:
                "col-lg-12 col-md-12 validation-text-fileuploader",
        },
    },
]


export const HideShowProfessionalInfoFieldsConfig = [
    {
        id: "isOtherProfessionalReason",
        label: "Others",
        Field_Name: "Others",
        fieldType: FormFieldTypes.INPUT,
        dataField: "isOtherProfessionalReason",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
]


export const HideShowOtherQualificationFieldConfig = [
    {
        id: "highestQualificationOthers",
        label: "Others",
        Field_Name: "Others",
        fieldType: FormFieldTypes.INPUT,
        dataField: "highestQualificationOthers",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
]

export const HideShowAllCurrentEmployeeConfig = [
    {
        id: "organisationCompany",
        label: "Organisation / Company",
        Field_Name: "Organisation / Company",
        fieldType: FormFieldTypes.INPUT,
        dataField: "organisationCompany",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "jobTitle",
        label: "Job Title",
        Field_Name: "Job Title",
        fieldType: FormFieldTypes.INPUT,
        dataField: "jobTitle",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "jobRoleId",
        label: "Job Role",
        Field_Name: "Job Role",
        fieldType: FormFieldTypes.SELECT,
        dataField: "jobRoleId",
        fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
        },
        validation: [{ type: validationTypes.REQUIRE }],
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "organisationAddressLine1",
        label: "Organisation Address Line 1",
        Field_Name: "Organisation Address Line 1",
        fieldType: FormFieldTypes.INPUT,
        dataField: "organisationAddressLine1",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "organisationAddressLine2",
        label: "Organisation Address Line 2",
        Field_Name: "Organisation Address Line 2",
        fieldType: FormFieldTypes.INPUT,
        dataField: "organisationAddressLine2",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "organisationAddressLine3",
        label: "Organisation Address Line 3",
        Field_Name: "Organisation Address Line 3",
        fieldType: FormFieldTypes.INPUT,
        dataField: "organisationAddressLine3",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "empCountryId",
        label: "Country",
        Field_Name: "Country",
        fieldType: FormFieldTypes.SELECT,
        dataField: "empCountryId",
        fieldSetting: {
            placeholder: "Select",
            allowSpace: true,
            options: [],
        },
        style: {
            containerCss: "col-lg-12 col-md-12 mb-2",
        },
    },
    {
        id: "empPostalCode",
        label: "Postal Code",
        Field_Name: "Postal Code",
        fieldType: FormFieldTypes.NUMERIC,
        dataField: "empPostalCode",
        fieldSetting: {
            placeholder: "",
            // masking: {
            //   isMasking: true,
            //   showMask: true,
            //   maskFormat: '___-___',
            //   maskPlaceholder: "",
            //   maskReplacement: { _: /\d/ },
            // },
        },
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "empEmailAddress",
        label: (<span>Email Address (if different from above)<span className="validation-star">*</span></span>),
        // label: "Email Address (if different from above)",
        Field_Name: "Email Address (if different from above)",
        fieldType: FormFieldTypes.INPUT,
        dataField: "empEmailAddress",
        fieldSetting: {
            placeholder: "",
            allowSpace: true,
        },
        validation: [{ type: validationTypes.EMAIL }],
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
    {
        id: "empMobile",
        label: "Mobile (if different from above)",
        Field_Name: "Mobile (if different from above)",
        fieldType: FormFieldTypes.PHONE,
        dataField: "empMobile",
        fieldSetting: {
            placeholder: "",
            defaultCountry: "sg",
            allowSpace: true,
        },
        style: {
            containerCss: "col-lg-12 col-md-12 ",
        },
    },
]
export const HideShowCurrentEmployeeConfig = [
    "organisationCompany",
    "jobTitle",
    "jobRoleId",
    "organisationAddressLine1",
    "organisationAddressLine2",
    "organisationAddressLine3",
    "empCountryId",
    "empPostalCode",
    "empEmailAddress",
    "empMobile",
] 